<template>
    <div v-loading="pageLoading" id="app">
        <router-view/>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters([
			'pageLoading','catch_components'
		])
	},
	mounted() {
		// 禁止浏览器前进后退
		window.onpopstate = () => {
			this.$store.commit('app/SET_FORBID_BACK',true);
		}
	},
}
</script>
<style lang="scss">
html,body,#app{
    width: 100%;
	height: 100%;
    // overflow: hidden;
}
.el-loading-mask{
	z-index: 999999999 !important;
}
/* 解决表格错位 */
.mgrTable col[name='gutter'] {
    width: 20px!important;
}
.el-dialog__body{
	padding: 20px;
}
</style>
